import React from "react";
import { Sneakers } from "../Components/Sneakers";

export const Index = () => {
  return (
    <div>
      <Sneakers />
    </div>
  );
};
